import { isEscape, returnFocus, trapFocus, throttle } from "./utils.js";

var returnFocusTo = window.returnFocusTo || null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

/*
On page visible
*/
window.addEventListener("load", e => {
    // doing this "late" so it doesn't animate until things are visible
    const pageHeader = document.querySelector('.page-header');
    if (pageHeader) {
        pageHeader.classList.add('ready');
    }
    const groupsWithSlash = document.querySelectorAll('.has-slash');
    groupsWithSlash.forEach(el => {
        el.classList.add('ready');
    });
});


/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

/*
Mobile UI
*/
document.getElementById('site-navigation-open').addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.add('menu-open');
});

document.getElementById('site-navigation-close').addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.remove('menu-open');
});

/*
Scroll events
*/
window.addEventListener('scroll', throttle(100, function () {
    if (window.scrollY > 50) {
        document.body.classList.add('is-scrolled');
        return;
    }
    document.body.classList.remove('is-scrolled');
}));

const logoTickers = document.querySelectorAll('.wp-block-pulp-logo-ticker .logo');
window.addEventListener('scroll', e => {
    logoTickers.forEach(el => {
        const rect = el.getBoundingClientRect();
        let position = 100 * (rect.bottom / (window.innerHeight + rect.height));
        // use position - (100 - position) to go edge to edge
        el.style.setProperty("--position", position - 50 + "%");
    });
});

/*
DOM modifications
*/
const headlinesWithRotators = document.querySelectorAll('.is-style-rotator');
headlinesWithRotators.forEach(el => {
    const html = el.innerHTML;
    el.innerHTML = html + window.businessUnusualRotator;
});
